import React from 'react';
import { CheckCircle2, AlertCircle } from 'lucide-react';
interface ActivityProgressBadgeProps {
  currentStep: number;
  totalSteps?: number;
  percentage: number;
  isCompleted: boolean;
  isOverdue: boolean;
  size?: 'sm' | 'md';
}
export function ActivityProgressBadge({
  currentStep,
  totalSteps = 5,
  percentage,
  isCompleted,
  isOverdue,
  size = 'sm'
}: ActivityProgressBadgeProps) {
  if (isCompleted) {
    return <div className={`flex items-center gap-1.5 ${size === 'sm' ? 'text-xs' : 'text-sm'}`} data-id="element-461">
        <CheckCircle2 className={`${size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} text-green-500`} data-id="element-462" />
        <span className="font-semibold text-green-700" data-id="element-463">Completata</span>
        <span className="text-green-500 font-medium" data-id="element-464">100%</span>
      </div>;
  }
  if (isOverdue) {
    return <div className="space-y-1" data-id="element-465">
        <div className={`flex items-center gap-1.5 ${size === 'sm' ? 'text-xs' : 'text-sm'}`} data-id="element-466">
          <AlertCircle className={`${size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} text-red-500`} data-id="element-467" />
          <span className="font-semibold text-red-700" data-id="element-468">Scaduta</span>
          <span className="text-red-500 font-medium" data-id="element-469">
            Step {currentStep}/{totalSteps} · {percentage}%
          </span>
        </div>
        <div className={`w-full bg-red-100 rounded-full ${size === 'sm' ? 'h-1' : 'h-1.5'} overflow-hidden`} data-id="element-470">
          <div className="bg-red-500 h-full rounded-full transition-all duration-300" style={{
          width: `${percentage}%`
        }} data-id="element-471" />
        </div>
      </div>;
  }
  return <div className="space-y-1" data-id="element-472">
      <div className={`flex items-center gap-1.5 ${size === 'sm' ? 'text-xs' : 'text-sm'}`} data-id="element-473">
        <span className="font-medium text-slate-600" data-id="element-474">
          Step {currentStep}/{totalSteps}
        </span>
        <span className="font-semibold text-seform-orange" data-id="element-475">{percentage}%</span>
      </div>
      <div className={`w-full bg-slate-100 rounded-full ${size === 'sm' ? 'h-1' : 'h-1.5'} overflow-hidden`} data-id="element-476">
        <div className="bg-seform-orange h-full rounded-full transition-all duration-300" style={{
        width: `${percentage}%`
      }} data-id="element-477" />
      </div>
    </div>;
}